import styled from '@emotion/styled';
import { string } from 'prop-types';

import CircleProgressBarBase from './CircleProgressBarBase';

const CircleProgressBar = styled(CircleProgressBarBase)`
  max-width: ${props => props.maxSize};
  vertical-align: middle;
  .counter-text {
    fill: ${props => props.textColor};
    transform: translateY(0.25em);    
  }  
`;

CircleProgressBar.propTypes = {
    textColor: string,
    strokeColor: string,
    maxSize: string
};

CircleProgressBar.defaultProps = {
    textColor: '#05164d',
    strokeColor: '#ffad00',
    maxSize: '30vh'
};

export default CircleProgressBar;